export default function MySQL_EXERCISES() {
  return (
    <div>
      <h2>MySQL_EXERCISES</h2>    </div>
  );
}